import React from 'react';
import { NavLink } from 'react-router-dom';
import Navbar from '../Navbars/Navbar';
import Footer from '../Footer';

function BecomeARider() {
    return (
        <>
            <Navbar />

            {/* Hero */}
            <div className="bg-gradient-to-br from-[#1C1C1C] to-[#2D2D2D] relative overflow-hidden">
                <div className="absolute inset-0 opacity-5">
                    <div className="absolute top-0 left-0 w-full h-full" style={{
                        backgroundImage: 'radial-gradient(circle, #E04343 1px, transparent 1px)',
                        backgroundSize: '30px 30px'
                    }} />
                </div>
                <div className="relative xl:max-w-[1280px] mx-auto px-6 sm:px-16 py-16 md:py-24 text-center">
                    <div className="inline-flex items-center gap-2 bg-[#E04343] bg-opacity-20 border border-[#E04343] border-opacity-40 rounded-full px-4 py-1.5 mb-6">
                        <span className="w-2 h-2 bg-[#E04343] rounded-full animate-pulse" />
                        <span className="text-[#E04343] text-[12px] font-bold uppercase tracking-wider">Now Accepting Applications</span>
                    </div>
                    <h1 className="text-white text-[32px] md:text-[52px] font-extrabold leading-tight mb-5">
                        Deliver With <span className="text-[#E04343]">Skynet</span>. <br className="hidden md:block" />
                        Earn On Your Terms.
                    </h1>
                    <p className="text-gray-300 text-[16px] md:text-[18px] max-w-[650px] mx-auto mb-8 leading-relaxed">
                        Whether you're an independent rider looking to earn per delivery or a fleet operator wanting to manage a team of riders — Skynet has an opportunity for you.
                    </p>
                    <div className="flex flex-col sm:flex-row gap-4 justify-center">
                        <NavLink to="/rider-registration">
                            <button className="bg-[#E04343] hover:bg-[#c93636] text-white rounded-full py-[14px] px-[40px] text-[16px] font-bold uppercase tracking-wide transition-all duration-300 shadow-lg shadow-red-900/30 w-full sm:w-auto">
                                Apply as Rider
                            </button>
                        </NavLink>
                        <NavLink to="/fleet-registration">
                            <button className="border-2 border-white hover:border-[#E04343] text-white hover:text-[#E04343] rounded-full py-[14px] px-[40px] text-[16px] font-bold uppercase tracking-wide transition-all duration-300 w-full sm:w-auto">
                                Apply as Fleet Agent
                            </button>
                        </NavLink>
                    </div>
                </div>
            </div>

            {/* Two Paths */}
            <div className="bg-white sm:px-16 px-6 py-12 md:py-20">
                <div className="xl:max-w-[1280px] mx-auto">
                    <div className="text-center mb-12">
                        <h2 className="text-[26px] md:text-[34px] font-bold text-[#1C1C1C]">Two Ways To Earn</h2>
                        <div className="w-[80px] h-1 bg-[#E04343] mx-auto mt-3" />
                        <p className="text-gray-500 text-[15px] mt-4 max-w-[500px] mx-auto">Choose the path that fits your situation. Both offer competitive earnings and full support from Skynet.</p>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                        {/* Rider Card */}
                        <div className="border-2 border-gray-200 hover:border-[#E04343] rounded-2xl p-8 transition-all duration-300 hover:shadow-xl group">
                            <div className="w-16 h-16 bg-blue-100 rounded-2xl flex items-center justify-center mb-6 group-hover:bg-[#E04343] group-hover:bg-opacity-10 transition-colors">
                                <svg className="w-8 h-8 text-blue-600 group-hover:text-[#E04343] transition-colors" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                                </svg>
                            </div>
                            <h3 className="text-[22px] font-bold text-[#1C1C1C] mb-3">Delivery Rider</h3>
                            <p className="text-gray-500 text-[15px] leading-relaxed mb-6">
                                Pick up and deliver packages in your area. You earn a fixed rate per delivery — metro rate for within your town, and a higher rate for deliveries outside your town. Get paid directly to your bank account.
                            </p>
                            <div className="space-y-3 mb-8">
                                {[
                                    'Earn up to 1K per delivery',
                                    'Flexible schedule — deliver when you want',
                                    'Get paid directly to your bank',
                                    'No vehicle required — bike, car, or on foot',
                                    'Real-time tracking of your earnings',
                                    'Join independently or under a fleet agent',
                                ].map((item, i) => (
                                    <div key={i} className="flex items-start gap-3">
                                        <svg className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                                            <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                                        </svg>
                                        <span className="text-[14px] text-gray-600">{item}</span>
                                    </div>
                                ))}
                            </div>
                            <NavLink to="/rider-registration">
                                <button className="w-full bg-[#E04343] hover:bg-[#c93636] text-white rounded-full py-[12px] text-[15px] font-bold uppercase tracking-wide transition-all duration-300">
                                    Apply as Rider
                                </button>
                            </NavLink>
                        </div>

                        {/* Fleet Agent Card */}
                        <div className="border-2 border-gray-200 hover:border-[#E04343] rounded-2xl p-8 transition-all duration-300 hover:shadow-xl group">
                            <div className="w-16 h-16 bg-purple-100 rounded-2xl flex items-center justify-center mb-6 group-hover:bg-[#E04343] group-hover:bg-opacity-10 transition-colors">
                                <svg className="w-8 h-8 text-purple-600 group-hover:text-[#E04343] transition-colors" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                                </svg>
                            </div>
                            <h3 className="text-[22px] font-bold text-[#1C1C1C] mb-3">Fleet Agent</h3>
                            <p className="text-gray-500 text-[15px] leading-relaxed mb-6">
                                Build and manage your own team of riders under Skynet. Your riders deliver packages, and all their earnings flow into your fleet wallet. You manage your team, we handle the rest.
                            </p>
                            <div className="space-y-3 mb-8">
                                {[
                                    'Earn from every delivery your riders make',
                                    'Add and manage your own riders',
                                    'Fleet wallet receives all rider earnings',
                                    'Dashboard to track rider performance',
                                    'Withdraw anytime to your bank account',
                                    'Scale your fleet — no limit on riders',
                                ].map((item, i) => (
                                    <div key={i} className="flex items-start gap-3">
                                        <svg className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                                            <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                                        </svg>
                                        <span className="text-[14px] text-gray-600">{item}</span>
                                    </div>
                                ))}
                            </div>
                            <NavLink to="/fleet-registration">
                                <button className="w-full bg-[#1C1C1C] hover:bg-[#333] text-white rounded-full py-[12px] text-[15px] font-bold uppercase tracking-wide transition-all duration-300">
                                    Apply as Fleet Agent
                                </button>
                            </NavLink>
                        </div>
                    </div>
                </div>
            </div>

            {/* How It Works */}
            <div className="bg-[#FAFAFA] sm:px-16 px-6 py-12 md:py-20">
                <div className="xl:max-w-[1280px] mx-auto">
                    <div className="text-center mb-12">
                        <h2 className="text-[26px] md:text-[34px] font-bold text-[#1C1C1C]">How It Works</h2>
                        <div className="w-[80px] h-1 bg-[#E04343] mx-auto mt-3" />
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
                        {[
                            { step: '01', title: 'Apply Online', desc: 'Fill out the application form with your personal details, NIN, and upload your documents.', color: 'bg-blue-100 text-blue-700' },
                            { step: '02', title: 'NIN Verification', desc: 'We verify your identity through Dojah NIN verification. This usually takes less than 24 hours.', color: 'bg-yellow-100 text-yellow-700' },
                            { step: '03', title: 'Admin Approval', desc: 'Our team reviews your application and sets your delivery rates. You get an email once approved.', color: 'bg-green-100 text-green-700' },
                            { step: '04', title: 'Start Earning', desc: 'Download the Skynet rider app, pick up deliveries, and earn money per successful delivery.', color: 'bg-purple-100 text-purple-700' },
                        ].map((item, i) => (
                            <div key={i} className="text-center">
                                <div className={`w-16 h-16 ${item.color} rounded-full flex items-center justify-center mx-auto mb-4`}>
                                    <span className="text-[20px] font-extrabold">{item.step}</span>
                                </div>
                                <h4 className="text-[17px] font-bold text-[#1C1C1C] mb-2">{item.title}</h4>
                                <p className="text-gray-500 text-[14px] leading-relaxed">{item.desc}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            {/* Requirements */}
            <div className="bg-white sm:px-16 px-6 py-12 md:py-20">
                <div className="xl:max-w-[1280px] mx-auto">
                    <div className="text-center mb-12">
                        <h2 className="text-[26px] md:text-[34px] font-bold text-[#1C1C1C]">What You Need</h2>
                        <div className="w-[80px] h-1 bg-[#E04343] mx-auto mt-3" />
                        <p className="text-gray-500 text-[15px] mt-4">Simple requirements to get started</p>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-[800px] mx-auto">
                        {/* Rider Requirements */}
                        <div className="bg-[#FAFAFA] rounded-2xl p-6">
                            <h4 className="text-[18px] font-bold text-[#1C1C1C] mb-4">For Riders</h4>
                            <div className="space-y-3">
                                {[
                                    'Valid NIN (National Identification Number)',
                                    'Passport photograph',
                                    'Valid means of identification',
                                    'Bank account for payments',
                                    'Smartphone for the rider app',
                                    'Next of kin information',
                                    'Guarantor information',
                                ].map((item, i) => (
                                    <div key={i} className="flex items-center gap-3">
                                        <svg className="w-5 h-5 text-[#E04343] flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                                            <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                                        </svg>
                                        <span className="text-[14px] text-gray-600">{item}</span>
                                    </div>
                                ))}
                            </div>
                        </div>

                        {/* Fleet Agent Requirements */}
                        <div className="bg-[#FAFAFA] rounded-2xl p-6">
                            <h4 className="text-[18px] font-bold text-[#1C1C1C] mb-4">For Fleet Agents</h4>
                            <div className="space-y-3">
                                {[
                                    'All rider requirements above',
                                    'Registered business name (optional)',
                                    'CAC certificate (if registered)',
                                    'Ability to manage a team of riders',
                                    'Commitment to delivery quality',
                                ].map((item, i) => (
                                    <div key={i} className="flex items-center gap-3">
                                        <svg className="w-5 h-5 text-[#E04343] flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                                            <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                                        </svg>
                                        <span className="text-[14px] text-gray-600">{item}</span>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* FAQ */}
            <div className="bg-[#FAFAFA] sm:px-16 px-6 py-12 md:py-20">
                <div className="xl:max-w-[800px] mx-auto">
                    <div className="text-center mb-12">
                        <h2 className="text-[26px] md:text-[34px] font-bold text-[#1C1C1C]">Common Questions</h2>
                        <div className="w-[80px] h-1 bg-[#E04343] mx-auto mt-3" />
                    </div>

                    <div className="space-y-4">
                        {[
                            { q: 'How much can I earn as a rider?', a: 'Earnings depend on the number of deliveries you make. Each delivery has a fixed rate — metro rate for within your town and a higher rate for outside your town. Most active riders earn ₦5,000 – ₦15,000+ daily.' },
                            { q: 'Do I need my own vehicle?', a: 'Not necessarily. You can deliver by motorcycle, car, or even on foot for local deliveries. Many of our riders use motorcycles for efficiency.' },
                            { q: 'How do I get paid?', a: 'After delivering a package and getting proof of delivery confirmed, your earnings are credited to your in-app wallet. You can withdraw anytime to your verified bank account via Paystack.' },
                            { q: 'What is a fleet agent?', a: 'A fleet agent manages a team of riders. When your riders complete deliveries, the earnings go to your fleet wallet. You manage your team and withdraw earnings to your bank account.' },
                            { q: 'How long does approval take?', a: 'NIN verification usually completes within minutes. Once verified, our admin team reviews and approves your application within 24–48 hours. You get an email notification once approved.' },
                            { q: 'Can I be a rider and a fleet agent?', a: 'No, you register as either a rider or a fleet agent. If you want to manage riders, register as a fleet agent. If you want to deliver packages yourself, register as a rider.' },
                        ].map((item, i) => (
                            <details key={i} className="bg-white rounded-xl border border-gray-200 group">
                                <summary className="flex items-center justify-between cursor-pointer p-5 text-[15px] font-semibold text-[#1C1C1C] list-none">
                                    {item.q}
                                    <svg className="w-5 h-5 text-gray-400 group-open:rotate-180 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                                    </svg>
                                </summary>
                                <div className="px-5 pb-5 text-[14px] text-gray-600 leading-relaxed">
                                    {item.a}
                                </div>
                            </details>
                        ))}
                    </div>
                </div>
            </div>

            {/* Final CTA */}
            <div className="bg-[#E04343] sm:px-16 px-6 py-12 md:py-16">
                <div className="xl:max-w-[800px] mx-auto text-center">
                    <h2 className="text-white text-[26px] md:text-[36px] font-extrabold mb-4">Ready to Start Earning?</h2>
                    <p className="text-white text-opacity-80 text-[15px] mb-8 max-w-[450px] mx-auto">Join hundreds of riders and fleet agents already earning with Skynet. The application takes less than 5 minutes.</p>
                    <div className="flex flex-col sm:flex-row gap-4 justify-center">
                        <NavLink to="/rider-registration">
                            <button className="bg-white text-[#E04343] hover:bg-gray-100 rounded-full py-[14px] px-[40px] text-[16px] font-bold uppercase tracking-wide transition-all duration-300 w-full sm:w-auto">
                                Apply as Rider
                            </button>
                        </NavLink>
                        <NavLink to="/fleet-registration">
                            <button className="border-2 border-white text-white hover:bg-white hover:text-[#E04343] rounded-full py-[14px] px-[40px] text-[16px] font-bold uppercase tracking-wide transition-all duration-300 w-full sm:w-auto">
                                Apply as Fleet Agent
                            </button>
                        </NavLink>
                    </div>
                </div>
            </div>

            <Footer />
        </>
    );
}

export default BecomeARider;